import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, unref as _unref, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { reactive, computed, ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import Modal from '@/hooks/modalType'
import { message } from '@dc-platform/dc-components'
import { planStatusEnum, remindTypeEnum } from '../dataConfig'
import { listByParamCodes } from '@/api/common'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import { visitorProgramList, visitorProgramDelete } from '@/api/gucangSales/followUpManage'
import type { ParamCodeItem } from '@/typings/common'
import type { FbuVisitorProgramParams, FbuVisitorProgramListItem } from '@/typings/api/followUpManage'

const __default__ = { name: 'DcCosFbuVisitorProgram' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const router = useRouter()

// 计划状态枚举
const planStatusEnumAll = [{ label: '全部', value: undefined }, ...planStatusEnum]
const statusEnum = planStatusEnum.map((item) => ({
  name: item.label,
  value: item.value,
  color: item.color
}))
const paramCodeData: {
  [key: string]: ParamCodeItem[]
} = reactive({
  fbu_follow_purpose: [], // 拜访目的
  fbu_follow_mode: [] // 拜访方式（跟进方式）
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_fbu',
    paramCodes: ['fbu_follow_purpose', 'fbu_follow_mode']
  }).then((res) => {
    Object.assign(paramCodeData, res.data)
  })
}
onMounted(() => getByParamCodes())

const tableRef = ref()
const queryForm = reactive<FbuVisitorProgramParams>({
  timeType: 0
})

const columns = computed(() => [
  {
    title: '计划标题',
    dataIndex: 'title',
    cosType: 'link',
    path: '/fbu/visitorProgram/view',
    query: ['id'],
    fixed: 'left',
    width: 200
  },
  { title: '主客户代码', dataIndex: 'customerNumber' },
  { title: '客户名称', dataIndex: 'customerName', width: 200 },
  { title: '拜访方式', dataIndex: 'mode', dicData: paramCodeData.fbu_follow_mode },
  { title: '目的', dataIndex: 'purpose', dicData: paramCodeData.fbu_follow_purpose },
  { title: '计划状态', dataIndex: 'status' },
  { title: '访客提醒', dataIndex: 'remindType', dicData: remindTypeEnum },
  { title: '客户负责人', dataIndex: 'dutyByName' },
  { title: '拜访时间', dataIndex: ['startTime', 'endTime'], cosType: 'timeRange', sorter: true },
  { title: '创建人', dataIndex: 'createByName' },
  { title: '创建时间', dataIndex: 'createTime', sorter: true },
  { title: '备注', dataIndex: 'remark' },
  { title: '操作', dataIndex: 'action', width: 200, fixed: 'right' }
])
const getList = (queryForm: FbuVisitorProgramParams, callBack: (res: any) => void) => {
  visitorProgramList(queryForm).then((res) => {
    callBack(res)
  })
}
const handleQueryChange = (type: 'search' | 'fetch') => {
  if (type === 'search') {
    tableRef.value?.search()
  } else {
    tableRef.value?.fetch()
  }
}

// 新增编辑函数
const triggerAddOrEdit = (id?: string) => {
  if (id) {
    router.push({ path: '/fbu/visitorProgram/edit', query: { id } })
  } else {
    router.push('/fbu/visitorProgram/add')
  }
}
const handleVisitComplete = (row: FbuVisitorProgramListItem) => {
  router.push({ path: '/fbu/followUpRecord/visitingPlan', query: { planId: row.id } })
}
const handleDelete = (row: FbuVisitorProgramListItem) => {
  Modal.delete({
    name: row.title,
    onOk() {
      visitorProgramDelete(row.id).then(() => {
        message.success('删除计划成功')
        tableRef.value?.delFetch()
      })
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_ParamCodesSelect = _resolveComponent("ParamCodesSelect")!
  const _component_UserSelect = _resolveComponent("UserSelect")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_CosRangePicker = _resolveComponent("CosRangePicker")!
  const _component_a_input_group = _resolveComponent("a-input-group")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_ExportButton = _resolveComponent("ExportButton")!
  const _component_dc_status = _resolveComponent("dc-status")!
  const _component_SellerButton = _resolveComponent("SellerButton")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, { "is-breadcrumb": true }, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_cos_table, {
            serial: "",
            columns: columns.value,
            search: queryForm,
            "onUpdate:search": _cache[12] || (_cache[12] = ($event: any) => ((queryForm) = $event)),
            onFetch: getList,
            ref_key: "tableRef",
            ref: tableRef,
            tableId: "DcCosLbuSalesClue"
          }, {
            search: _withCtx(() => [
              _createVNode(_component_a_form, { model: queryForm }, {
                default: _withCtx(() => [
                  _createVNode(_component_dc_form_item, { label: "计划状态" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_radio_group, {
                        value: queryForm.status,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.status) = $event)),
                        optionType: "button",
                        options: planStatusEnumAll,
                        onChange: _cache[1] || (_cache[1] = ($event: any) => (handleQueryChange('search')))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "主客户代码" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.customerNumber,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((queryForm.customerNumber) = $event)),
                        valueModifiers: { trim: true },
                        maxlength: 100,
                        placeholder: "请输入",
                        allowClear: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "客户名称" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.customerName,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((queryForm.customerName) = $event)),
                        valueModifiers: { trim: true },
                        maxlength: 100,
                        placeholder: "请输入",
                        allowClear: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "目的" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ParamCodesSelect, {
                        value: queryForm.purpose,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((queryForm.purpose) = $event)),
                        options: paramCodeData.fbu_follow_purpose,
                        placeholder: "请选择",
                        allowClear: ""
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "计划标题" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.title,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((queryForm.title) = $event)),
                        valueModifiers: { trim: true },
                        maxlength: 100,
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "组织部门" }, {
                    default: _withCtx(() => [
                      _createVNode(CustomerAreaCascader, {
                        type: "search",
                        appId: "cos_fbu",
                        ids: queryForm.deptIdList,
                        "onUpdate:ids": _cache[6] || (_cache[6] = ($event: any) => ((queryForm.deptIdList) = $event))
                      }, null, 8, ["ids"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "客户负责人" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_UserSelect, {
                        value: queryForm.dutyBy,
                        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((queryForm.dutyBy) = $event)),
                        placeholder: "请选择",
                        allowClear: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "时间筛选" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input_group, { compact: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_select, {
                            value: queryForm.timeType,
                            "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((queryForm.timeType) = $event)),
                            style: {"width":"33%"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_select_option, { value: 0 }, {
                                default: _withCtx(() => [
                                  _createTextVNode("创建时间")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_select_option, { value: 1 }, {
                                default: _withCtx(() => [
                                  _createTextVNode("拜访时间")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["value"]),
                          _createVNode(_component_CosRangePicker, {
                            startTime: queryForm.startTime,
                            "onUpdate:startTime": _cache[9] || (_cache[9] = ($event: any) => ((queryForm.startTime) = $event)),
                            endTime: queryForm.endTime,
                            "onUpdate:endTime": _cache[10] || (_cache[10] = ($event: any) => ((queryForm.endTime) = $event)),
                            style: {"width":"67%"}
                          }, null, 8, ["startTime", "endTime"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            button: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "primary",
                onClick: _cache[11] || (_cache[11] = ($event: any) => (triggerAddOrEdit()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("新增")
                ]),
                _: 1
              })), [
                [_directive_permission, 'fbu_visitor_add_btn']
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_ExportButton, {
                appId: "cos_fbu",
                taskType: "208",
                search: queryForm
              }, {
                default: _withCtx(() => [
                  _createTextVNode("导出")
                ]),
                _: 1
              }, 8, ["search"])), [
                [_directive_permission, 'fbu_visitor_export_btn']
              ])
            ]),
            bodyCell: _withCtx(({ column, record, text }) => [
              (column.dataIndex === 'status')
                ? (_openBlock(), _createBlock(_component_dc_status, {
                    key: 0,
                    enums: _unref(statusEnum),
                    value: text
                  }, null, 8, ["enums", "value"]))
                : _createCommentVNode("", true),
              (column.dataIndex === 'action')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _withDirectives((_openBlock(), _createBlock(_component_SellerButton, {
                      type: "link",
                      workCode: record.dutyBy,
                      disabled: record.status === 3,
                      onClick: ($event: any) => (handleVisitComplete(record))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("完成拜访")
                      ]),
                      _: 2
                    }, 1032, ["workCode", "disabled", "onClick"])), [
                      [_directive_permission, 'fbu_visitor_complete_btn']
                    ]),
                    _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                      type: "link",
                      disabled: record.status === 3,
                      onClick: ($event: any) => (triggerAddOrEdit(record.id))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("编辑")
                      ]),
                      _: 2
                    }, 1032, ["disabled", "onClick"])), [
                      [_directive_permission, 'fbu_visitor_edit_btn']
                    ]),
                    _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                      type: "link",
                      disabled: record.status === 3,
                      onClick: ($event: any) => (handleDelete(record))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("删除")
                      ]),
                      _: 2
                    }, 1032, ["disabled", "onClick"])), [
                      [_directive_permission, 'fbu_visitor_del_btn']
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["columns", "search"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})